var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "div",
        { staticClass: "emap-flow-next-step-m" },
        [
          _vm.cur_node_info.nodeName
            ? _c(
                "div",
                { staticClass: "emap-flow-next-step-item" },
                [
                  _c("van-cell", {
                    attrs: {
                      title: _vm.labels.cur_node,
                      value: _vm.cur_node_info.nodeName,
                      "title-class": "van-field__label",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.cur_node_info.documentation
            ? _c(
                "div",
                { staticClass: "emap-flow-next-step-item" },
                [
                  _c("van-cell", {
                    attrs: {
                      title: _vm.labels.cur_node_desc,
                      value: _vm.cur_node_info.documentation,
                      "title-class": "van-field__label",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showNextNode
            ? _c(
                "div",
                { staticClass: "emap-flow-next-step-item" },
                [
                  _vm.showNextNode
                    ? _c("van-cell", {
                        attrs: {
                          title: _vm.labels.node,
                          "is-link": _vm.node_list.length != 1,
                          value: _vm.node_display || _vm.nodeplaceholder,
                          required: _vm.required,
                          "value-class": _vm.nodeClass,
                          "title-class": "van-field__label",
                        },
                        on: { click: _vm.nodeClick },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "van-popup",
                    {
                      attrs: { position: "bottom", "get-container": "body" },
                      model: {
                        value: _vm.nodePopup,
                        callback: function ($$v) {
                          _vm.nodePopup = $$v
                        },
                        expression: "nodePopup",
                      },
                    },
                    [
                      _c("van-picker", {
                        attrs: {
                          "show-toolbar": "",
                          columns: _vm.node_list,
                          "value-key": "nodeName",
                          "default-index": _vm.nodeIdIndex,
                        },
                        on: {
                          cancel: function ($event) {
                            _vm.nodePopup = false
                          },
                          confirm: _vm.nodeConfirm,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showNextNode &&
          _vm.cur_node.documentation &&
          _vm.schema === "default"
            ? _c(
                "div",
                { staticClass: "emap-flow-next-step-item" },
                [
                  _c("van-cell", {
                    attrs: {
                      title: _vm.labels.node_desc,
                      value: _vm.cur_node.documentation,
                      "title-class": "van-field__label",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$slots.customItem
            ? _c(
                "div",
                { staticClass: "emap-flow-next-step-item" },
                [_vm._t("customItem")],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.cur_node.isEndNode !== "1" && _vm.showNextAssignees
            ? _c(
                "div",
                { staticClass: "emap-flow-next-step-item" },
                [
                  _vm.showNextAssignees
                    ? _c("van-cell", {
                        attrs: {
                          title: !_vm.isMultiInstance
                            ? _vm.labels.assignee
                            : _vm.labels.assigneeGroup,
                          "is-link": "",
                          value: _vm.assignee_display || "请选择",
                          required: _vm.required,
                          "value-class": _vm.assigneeClass,
                          "title-class": "van-field__label",
                        },
                        on: { click: _vm.assigneeClick },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "right-icon",
                              fn: function () {
                                return [
                                  _vm.node &&
                                  _vm.assignee_list.length != 1 &&
                                  !_vm.asyncAssignee
                                    ? _c("van-icon", {
                                        staticClass: "van-cell__right-icon",
                                        attrs: { name: "arrow" },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.asyncAssignee
                                    ? _c("van-loading", {
                                        attrs: {
                                          type: "spinner",
                                          size: "24px",
                                        },
                                      })
                                    : _vm._e(),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          2743192358
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "van-popup",
                    {
                      attrs: { position: "bottom", "get-container": "body" },
                      model: {
                        value: _vm.assigneesPopup,
                        callback: function ($$v) {
                          _vm.assigneesPopup = $$v
                        },
                        expression: "assigneesPopup",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "van-hairline--top-bottom van-picker__toolbar",
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "van-picker__cancel",
                              attrs: { type: "button" },
                              on: { click: _vm.assigneesCancel },
                            },
                            [_vm._v("取消")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "van-picker__confirm",
                              attrs: { type: "button" },
                              on: { click: _vm.assigneesConfirm },
                            },
                            [_vm._v("确认")]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("van-search", {
                        staticStyle: { padding: "5px 12px" },
                        attrs: {
                          "show-action": "",
                          placeholder: "请输入搜索关键词",
                        },
                        on: { clear: _vm.onClear, search: _vm.onSearch },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "action",
                              fn: function () {
                                return [
                                  _c(
                                    "div",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.onSearch(_vm.keyword)
                                        },
                                      },
                                    },
                                    [_vm._v("搜索")]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          661607554
                        ),
                        model: {
                          value: _vm.keyword,
                          callback: function ($$v) {
                            _vm.keyword =
                              typeof $$v === "string" ? $$v.trim() : $$v
                          },
                          expression: "keyword",
                        },
                      }),
                      _vm._v(" "),
                      _vm.isMultiInstance || _vm.multiple
                        ? [
                            _c(
                              "van-checkbox-group",
                              {
                                staticClass: "checkbox-group-container",
                                model: {
                                  value: _vm.assigneesChecked,
                                  callback: function ($$v) {
                                    _vm.assigneesChecked = $$v
                                  },
                                  expression: "assigneesChecked",
                                },
                              },
                              [
                                _c(
                                  "van-cell-group",
                                  _vm._l(
                                    _vm.assignee_list,
                                    function (item, index) {
                                      return _c(
                                        "van-cell",
                                        {
                                          key: index,
                                          attrs: { clickable: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.toggle(index)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "van-checkbox",
                                            {
                                              ref: "checkboxes",
                                              refInFor: true,
                                              staticStyle: {
                                                "min-height": "24px",
                                              },
                                              attrs: {
                                                name: item.userId,
                                                shape: "square",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(item.display) +
                                                  "\n              "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        : [
                            _c(
                              "van-radio-group",
                              {
                                staticClass: "checkbox-group-container",
                                model: {
                                  value: _vm.assigneesChecked,
                                  callback: function ($$v) {
                                    _vm.assigneesChecked = $$v
                                  },
                                  expression: "assigneesChecked",
                                },
                              },
                              [
                                _c(
                                  "van-cell-group",
                                  _vm._l(
                                    _vm.assignee_list,
                                    function (item, index) {
                                      return _c(
                                        "van-cell",
                                        {
                                          key: index,
                                          attrs: { clickable: "" },
                                          on: {
                                            click: function ($event) {
                                              _vm.assigneesChecked ===
                                                item.userId
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "van-radio",
                                            {
                                              attrs: {
                                                slot: "right-icon",
                                                name: item.userId,
                                              },
                                              slot: "right-icon",
                                            },
                                            [_vm._v(_vm._s(item.display))]
                                          ),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                    ],
                    2
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.canCustom && _vm.defaultCustom
            ? _c("tg-tree", {
                attrs: {
                  "key-id": _vm.assignees,
                  "key-name": _vm.keyName,
                  options: _vm.treeOptions,
                  "search-options": _vm.treeSearchOptions,
                  "parent-selectable": false,
                  "is-view": false,
                  "is-async": true,
                  multiple: _vm.multiple,
                  hasSearch: "",
                },
                on: {
                  "on-search": _vm.$_loadtreeSearch,
                  "selector-click": _vm.$_loadTreeOptions,
                  "selected-click": _vm.$_getNextAssigneesSelected,
                },
                model: {
                  value: _vm.customAssigneesPopup,
                  callback: function ($$v) {
                    _vm.customAssigneesPopup = $$v
                  },
                  expression: "customAssigneesPopup",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.cur_node.isEndNode !== "1" &&
          _vm.showAddNextAssignees &&
          !_vm.addAssigneeHidden
            ? _c(
                "div",
                { staticClass: "emap-flow-next-step-item" },
                [
                  _c("van-cell", {
                    attrs: {
                      title: _vm.labels.addAssignee,
                      "is-link": "",
                      value: _vm.add_assignees_display || "请选择",
                      required: false,
                      "value-class": _vm.assigneeClass,
                      "title-class": "van-field__label",
                    },
                    on: { click: _vm.add_assigneeClick },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "right-icon",
                          fn: function () {
                            return [
                              _vm.node && !_vm.asyncAssignee
                                ? _c("van-icon", {
                                    staticClass: "van-cell__right-icon",
                                    attrs: { name: "arrow" },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.asyncAssignee
                                ? _c("van-loading", {
                                    attrs: { type: "spinner", size: "24px" },
                                  })
                                : _vm._e(),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      3281861989
                    ),
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("tg-tree", {
            attrs: {
              "key-id": _vm.assigneesAdd,
              "key-name": _vm.keyName2,
              options: _vm.treeOptions,
              "search-options": _vm.treeSearchOptions,
              "parent-selectable": false,
              "is-view": false,
              "is-async": true,
              multiple: "",
              hasSearch: "",
            },
            on: {
              "on-search": _vm.$_loadtreeSearch,
              "selector-click": _vm.$_loadTreeOptions,
              "selected-click": _vm.$_getAddAssigneesSelected,
            },
            model: {
              value: _vm.add_assigneesPopup,
              callback: function ($$v) {
                _vm.add_assigneesPopup = $$v
              },
              expression: "add_assigneesPopup",
            },
          }),
          _vm._v(" "),
          _vm.hasCirculate
            ? _c(
                "div",
                { staticClass: "emap-flow-next-step-item" },
                [
                  _c("van-cell", {
                    attrs: {
                      title: _vm.labels.circulator,
                      "is-link": "",
                      value: _vm.circulator_display || _vm.assigneeplaceholder,
                      required: _vm.required,
                      "value-class": _vm.circulatorClass,
                      "title-class": "van-field__label",
                    },
                    on: { click: _vm.circulatorClick },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "right-icon",
                          fn: function () {
                            return [
                              _c("van-icon", {
                                staticClass: "van-cell__right-icon",
                                attrs: { name: "arrow" },
                              }),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      2567720951
                    ),
                  }),
                  _vm._v(" "),
                  _vm.circulatorSelectFalg
                    ? _c(
                        "van-popup",
                        {
                          attrs: {
                            position: "bottom",
                            "get-container": "body",
                          },
                          model: {
                            value: _vm.circulatorsPopup,
                            callback: function ($$v) {
                              _vm.circulatorsPopup = $$v
                            },
                            expression: "circulatorsPopup",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "van-hairline--top-bottom van-picker__toolbar",
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "van-picker__cancel",
                                  attrs: { type: "button" },
                                  on: { click: _vm.circulatorsCancel },
                                },
                                [_vm._v("取消")]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "van-picker__confirm",
                                  attrs: { type: "button" },
                                  on: { click: _vm.circulatorsConfirm },
                                },
                                [_vm._v("确认")]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          false
                            ? _c("van-search", {
                                staticStyle: { padding: "5px 12px" },
                                attrs: {
                                  "show-action": "",
                                  placeholder: "请输入搜索关键词",
                                },
                                on: {
                                  clear: _vm.onClear,
                                  search: _vm.onSearch,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "action",
                                      fn: function () {
                                        return [
                                          _c(
                                            "div",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onSearch(
                                                    _vm.keyword
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("搜索")]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  661607554
                                ),
                                model: {
                                  value: _vm.keyword,
                                  callback: function ($$v) {
                                    _vm.keyword =
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                  },
                                  expression: "keyword",
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          [
                            _c(
                              "van-checkbox-group",
                              {
                                staticClass: "checkbox-group-container",
                                model: {
                                  value: _vm.circulatorChecked,
                                  callback: function ($$v) {
                                    _vm.circulatorChecked = $$v
                                  },
                                  expression: "circulatorChecked",
                                },
                              },
                              [
                                _c(
                                  "van-cell-group",
                                  _vm._l(
                                    _vm.circulator_list,
                                    function (item, index) {
                                      return _c(
                                        "van-cell",
                                        {
                                          key: index,
                                          attrs: { clickable: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.toggle(index)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "van-checkbox",
                                            {
                                              ref: "checkboxes",
                                              refInFor: true,
                                              staticStyle: {
                                                "min-height": "24px",
                                              },
                                              attrs: {
                                                name: item.userId,
                                                shape: "square",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(item.display) +
                                                  "\n              "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                        ],
                        2
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.hasCirculate && !_vm.circulatorSelectFalg
            ? _c("tg-tree", {
                attrs: {
                  "key-id": _vm.circulators,
                  "key-name": _vm.keyName1,
                  options: _vm.treeOptions,
                  "search-options": _vm.treeSearchOptions,
                  "parent-selectable": false,
                  "is-view": false,
                  "is-async": true,
                  multiple: "",
                  hasSearch: "",
                },
                on: {
                  "on-search": _vm.$_loadtreeSearch,
                  "selector-click": _vm.$_loadTreeOptions,
                  "selected-click": _vm.$_getCirculatorSelected,
                },
                model: {
                  value: _vm.customCirculatorsPopup,
                  callback: function ($$v) {
                    _vm.customCirculatorsPopup = $$v
                  },
                  expression: "customCirculatorsPopup",
                },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }